import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { ADMIN_TOKEN_KEY } from "../../api";
import { toast } from "sonner";
import { Loader2, Shield } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@neuroeq.app");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/admin/auth/login", { email, password });
      localStorage.setItem(ADMIN_TOKEN_KEY, r.data.token);
      toast.success("Welcome to NeuroEQ Admin");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-[hsl(var(--neu-cream))] to-[hsl(var(--neu-paper))]">
      <form onSubmit={submit} className="card-elevated w-full max-w-md p-8" data-testid="admin-login-card">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-2xl bg-[hsl(var(--neu-ink))] flex items-center justify-center">
            <Shield className="w-6 h-6 text-white"/>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-muted-foreground">NeuroEQ</div>
            <h1 className="font-display text-2xl">Admin CMS</h1>
          </div>
        </div>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="Admin email" className="field mb-3" data-testid="admin-login-email"/>
        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="Password" className="field mb-5" data-testid="admin-login-password"/>
        <button disabled={busy} className="btn-dark w-full" data-testid="admin-login-submit">
          {busy ? <Loader2 className="w-4 h-4 animate-spin"/> : "Sign in"}
        </button>
      </form>
    </div>
  );
}
